import * as React from "react";
import { useState, useEffect } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { Loader } from "@progress/kendo-react-indicators";
import { toast } from "react-toastify";
import EditCategory from "./EditWorkType";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import {
  updateWorkType,
  useWorkTypes,
  getWorkTypesByDepartment,
} from "services/workTypeService";
import { GridLoader } from "components/GridLoader";

const WorkTypeList = ({ departmentID }) => {
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [workTypeData, setWorkTypeData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: workTypes, loading } = useWorkTypes();

  useEffect(() => {
    if (departmentID > 0) {
      const fetchDepartmentWorkTypes = async () => {
        try {
          const result = await getWorkTypesByDepartment(departmentID);
          setWorkTypeData(result?.data?.data || []);
        } catch (error) {
          console.error("Error fetching work types by department:", error);
        }
      };
      fetchDepartmentWorkTypes();
    } else {
      setWorkTypeData(null);
    }
  }, [departmentID]);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      const updatedData = {
        ...event,
        departmentId: event.departmentId?.departmentID || "",
        appCode: event.appCode?.appCode || "",
        rateCategoryId: event.rateCategoryId?.rateCategoryId || "",
        defaultProfitCost: event.defaultProfitCost?.nominalRef || "",
      };

      const result = await updateWorkType(updatedData.workTypeID, updatedData);

      if (result.success) {
        toast.success("Work Type updated successfully");
      } else {
        toast.error("Failed to update work type");
      }
    } catch (error) {
      toast.error("Error updating work type");
    } finally {
      setIsSubmitting(false);
      setOpenForm(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid h-100">
      <Grid data={workTypeData || workTypes} style={{ height: "100%" }} showLoader={loading} loader={
        <div style={{ height: "50px" }}>
          <GridLoader />
        </div>
      }>
        <GridNoRecords>
          {loading ? (
            <span></span>
          ) : (
            workTypeData && workTypeData?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column field="name" title=" " cell={SignatureCell} width="80px" />
        <Column field="code" title="Code" width="100px" />
        <Column field="name" title="Name" width="180px" />
        <Column field="department" title="Department" width="180px" />
        <Column cell={ActiveCell} title="Active" field="active" width="50px" />
        <Column title=" " cell={MyEditCommandCell} width="40px" />
      </Grid>

      {openForm && (
        <EditCategory
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default WorkTypeList;
